import styled from "styled-components";

const EditableTitle = styled.textarea.attrs({
  className: 'EditableTitle'
})`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  font-family: "PT Sans";
  line-height: 14px;
  margin-top: 2px;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  resize: none;
  overflow: hidden;
  min-height: 18px;
  height: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  align-content: center;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #999;
  }
`;

export default EditableTitle; 